import {
  FETCH_PROMPTS_REQUEST,
  FETCH_PROMPTS_SUCCESS,
  FETCH_PROMPTS_FAILURE,
  CREATE_PROMPT_REQUEST,
  CREATE_PROMPT_SUCCESS,
  CREATE_PROMPT_FAILURE,
  UPDATE_PROMPT_REQUEST,
  UPDATE_PROMPT_SUCCESS,
  UPDATE_PROMPT_FAILURE,
  DELETE_PROMPT_REQUEST,
  DELETE_PROMPT_SUCCESS,
  DELETE_PROMPT_FAILURE,
  FETCH_PROMPTS_BY_AGENT_REQUEST,
  FETCH_PROMPTS_BY_AGENT_SUCCESS,
  FETCH_PROMPTS_BY_AGENT_FAILURE,
  UPDATE_PROMPT_VERSION_STATUS_REQUEST,
  UPDATE_PROMPT_VERSION_STATUS_SUCCESS,
  UPDATE_PROMPT_VERSION_STATUS_FAILURE,
} from '../actions/promptAction';

const initialState = {
  prompts: [],
  loading: false,
  error: null,
};

const promptReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROMPTS_REQUEST:
    case FETCH_PROMPTS_BY_AGENT_REQUEST:
    case CREATE_PROMPT_REQUEST:
    case UPDATE_PROMPT_REQUEST:
    case DELETE_PROMPT_REQUEST:
    case UPDATE_PROMPT_VERSION_STATUS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PROMPTS_SUCCESS:
      return { ...state, loading: false, prompts: action.payload };

    case FETCH_PROMPTS_BY_AGENT_SUCCESS:
      console.log("Reducer received prompt data:", action.payload);  // Debugging Line

      return { 
        ...state, 
        loading: false, 
        prompts: action.payload && action.payload.placeholders ? [action.payload] : [],
      }

    case CREATE_PROMPT_SUCCESS:
      return { ...state, loading: false, prompts: [...state.prompts, action.payload] };

    case UPDATE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
        prompts: state.prompts.map((prompt) =>
          prompt.id === action.payload.id ? action.payload : prompt
        ),
      };

    case DELETE_PROMPT_SUCCESS:
      return {
        ...state,
        loading: false,
        prompts: state.prompts.filter((prompt) => prompt.id !== action.payload),
      };

    case UPDATE_PROMPT_VERSION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        prompts: state.prompts.map((prompt) =>
          prompt.id === action.payload.id ? { ...prompt, status: action.payload.status } : prompt
        ),
      };

    case FETCH_PROMPTS_FAILURE:
    case CREATE_PROMPT_FAILURE:
    case UPDATE_PROMPT_FAILURE:
    case DELETE_PROMPT_FAILURE:
    case FETCH_PROMPTS_BY_AGENT_FAILURE:
    case UPDATE_PROMPT_VERSION_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default promptReducer;
